export default class AntiForgeryService {
  private readonly getTokenUrl = "/fr-fr/antiforgery/GetToken"

  async getToken(): Promise<string> {
    const initConfig: RequestInit = {
      method: "GET",
      headers: {
        "content-type": "text/plain; charset=utf-8",
      },
      mode: "cors",
      cache: "no-cache",
    }

    const response = await fetch(this.getTokenUrl, initConfig)
    return await response.text()
  }
}
